jQuery(document).ready(function ($) {
    $('.woocommerce-tabs__item:not(.woocommerce-tabs__item--certificates) .woocommerce-tabs__item__title').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).parent().find('.woocommerce-product-attributes').hide();
        } else {
            $(this).addClass('active');
            $(this).parent().find('.woocommerce-product-attributes').show();
        }
    });
    $('.woocommerce-tabs__item--certificates .woocommerce-tabs__item__title').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).parent().find('.certificates__gallery').css('display', 'none');
        } else {
            $(this).addClass('active');
            $(this).parent().find('.certificates__gallery').css('display', 'flex');
        }
    });

    $('.single_add_to_cart_button').wrap('<div class="submit__box"></div>');
    $('.number_of_m2_in_the_package').appendTo('.submit__box');
    $('.pc_add_to_cart_form .quantity').wrap('<div class="quantity__box"></div>');
    $('.pc_add_to_cart_form .submit__box').appendTo('.quantity__box');

    if ($('body').hasClass('single-product') && $('div').hasClass('product_constant_width')) {
        var product_constant_width = $('.product_constant_width').text();
        $('#width_qty_area').val(product_constant_width);
        $('#width_qty_area').addClass('is__constant');
    }


// Create a clone of the menu, right next to original.
    $('.off-canvas-content .top__categories').addClass('original').clone().insertAfter('.off-canvas-content .top__categories').addClass('cloned').removeClass('original').hide();
    $('.off-canvas-content .header__bottom').addClass('original2').clone().insertAfter('.off-canvas-content .header__bottom').addClass('cloned2').removeClass('original2').hide();

    var scrollIntervalID = setInterval(stickIt, 10);


    function stickIt() {

        var orgElementPos = $('.original').offset();
        var orgElementTop = orgElementPos.top - 81;

        if ($(window).scrollTop() >= (orgElementTop)) {
            // scrolled past the original position; now only show the cloned, sticky element.

            // Cloned element should always have same left position and width as original element.     
            var orgElement = $('.original');
            var coordsOrgElement = orgElement.offset();
            var leftOrgElement = coordsOrgElement.left;
            var widthOrgElement = orgElement.css('width');
            $('.cloned').css('left', leftOrgElement + 'px').css('top', '81px').css('width', widthOrgElement).show();
            $('.original').css('visibility', 'hidden');
        } else {
            // not scrolled past the menu; only show the original menu.
            $('.cloned').hide();
            $('.original').css('visibility', 'visible');
        }
    }


    var scrollIntervalID2 = setInterval(stickIt2, 10);


    function stickIt2() {

        var orgElementPos = $('.original2').offset();
        var orgElementTop = orgElementPos.top;

        if ($(window).scrollTop() >= (orgElementTop)) {
            // scrolled past the original position; now only show the cloned, sticky element.

            // Cloned element should always have same left position and width as original element.     
            var orgElement = $('.original2');
            var coordsOrgElement = orgElement.offset();
            var leftOrgElement = coordsOrgElement.left;
            var widthOrgElement = orgElement.css('width');
            $('.cloned2').css('left', leftOrgElement + 'px').css('top', 0).css('width', widthOrgElement).show();
            $('.original2').css('visibility', 'hidden');
        } else {
            // not scrolled past the menu; only show the original menu.
            $('.cloned2').hide();
            $('.original2').css('visibility', 'visible');
        }
    }


//    $(document).on('found_variation', function (event, variation) {
//        var currency = $('.woocommerce-Price-currencySymbol').text();
//        $('.woocommerce-variation .woocommerce-variation-price').html('<span class="current"><span class="woocommerce-Price-amount amount">' + variation.display_price + '&nbsp;<span class="woocommerce-Price-currencySymbol">' + currency + '</span></span></span>');
//    });
});